import { Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

import { Prompt } from "./prompt";

const Prompts = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Prompt isEditable={true} prompt={t("chat.suggestedPrompts.1")} />
      <Prompt isEditable={false} prompt={t("chat.suggestedPrompts.2")} />
      <Prompt isEditable={true} prompt={t("chat.suggestedPrompts.3")} />
      <Prompt isEditable={false} prompt={t("chat.suggestedPrompts.4")} />
      <Prompt isEditable={false} prompt={t("chat.suggestedPrompts.5")} />
    </Fragment>
  );
};

export { Prompts };
